/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ShowHero/theme';

export const ShowHeroTheme = theme;
